<script>
import ContentBox from '@/components/ui/ContentBox';

export default {
  name: 'EmptyState',
  components: {
    ContentBox
  },
  props: {
    title: String
  }
};
</script>

<template>
  <content-box class="empty-state">
    <div class="empty-state-body">
      <h3 v-if="title" class="empty-state-title">
        {{ title }}
      </h3>
      <slot />
    </div>
  </content-box>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.empty-state {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 0;

  .empty-state-title {
    font-size: 1.2rem;
    color: $--color-gray-40;
    margin-bottom: 1.5rem;

    @include breakpoint('sm-and-down') {
      font-size: 1rem;
    }
  }
}
</style>
